export default __webpack_public_path__ + "static/media/hero-bcg.9898b660.jpg";